module.exports = __webpack_public_path__ + "static/media/3pic.e14331b2.png";